import styled from '@emotion/styled';
import {useState,useContext} from 'react';
import img from '../../../../images/default.png'
import { apiFormRequest } from '../../../../api';
import { useQueryClient,useMutation } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';
import { useSettingModal
 } from '../../../../hooks/Context';
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData, filterRouteName} from '../../../../hooks/FetchData'






const ViewDetails = (props:any) => {
    const data = props.data;
    const queryClient = useQueryClient();
    const [a_loading,set_a_loading] = useState<boolean>(false);
    const [r_loading,set_r_loading] = useState<boolean>(false);
    const {showNotification} = useContext(NotificationContext);
    const {setShowModal,setShowCancel} = useSettingModal();


    const {data: allRoutesData} = FetchAllRoutes();
    const reOrderedAllRoutes = allRoutesData ? reOrderFetchedData((allRoutesData as RouteResponse )?.Data) : []


    const handleApproveRequest = async(arg:string) =>{

        const apiData = new FormData();
        apiData.append('Id',data.Id?data.Id:'1');
        apiData.append('IsNewApplicant',data.IsNewApplicant);
        apiData.append('Name',data.Name);
        apiData.append('PreviousEmail',data.PreviousEmail);
        apiData.append('PhoneNumber',data.PhoneNumber);
        apiData.append('ApplicationType',data.ApplicationType);
        apiData.append('Status',arg||'Treated');
        return await apiFormRequest('api/Applicant/UpdateApplicantExistingByAppId', apiData);
    }
    const updateOldApplicants = useMutation(handleApproveRequest,{
        
        onSuccess(data, variables, context) {
            
                showNotification({
                    message:variables == 'Treated'?'Updated successfully':'Rejected Successfully',
                    type:'success'
                })
            
           
            
            queryClient.invalidateQueries([`existing_applicant`])
            queryClient.invalidateQueries(['oldTreated'])
            queryClient.invalidateQueries(['oldRejected'])
        },
        onError(error:any, variables, context) {
            showNotification({
                message:error?.Message,
                type:'error'
            })
        },
        onSettled(data, error, variables, context) {
            set_a_loading(false);
            set_r_loading(false);
            setShowCancel(true);
            setShowModal(false);
        },
    })

    const handleApprove = (arg:string='Treated') =>{
        set_a_loading(true);
        updateOldApplicants.mutate(arg);
    }
    const handleReject = (arg:string='Reject') =>{
        set_r_loading(true);
        updateOldApplicants.mutate(arg);
    }
  return (
    <Wrapper>
        <div>
            <img src={img} alt="profile" />
            <div>
                <span>{data.Name}</span>
                {/* <span>{`${filterRouteName(data?.RouteId, reOrderedAllRoutes)}`} </span> */}
            </div>
        </div>
        <div >
            <EachDetails label="Name" value={data.Name} />
            <EachDetails label="Email Address" value={data.PreviousEmail} />
            <EachDetails label="Phone Number" value={data.PhoneNumber} />
            {/* <EachDetails label="Route" value={filterRouteName(data?.RouteId, reOrderedAllRoutes)} />  */}
            <EachDetails label="Status" value={data.Status} /> 
            <CenterBtnDiv>
                <button disabled={a_loading} onClick={()=>handleReject('Reject')} className='decline'  >
                   {r_loading?'Loading...':'Reject'}
                </button>
                <button disabled={a_loading} onClick={()=>handleApprove('Treated')} className='approve'>
                    {a_loading?'Loading...':'Update'}
                </button>
            </CenterBtnDiv>         
        </div>
    </Wrapper>
  )
}

export default ViewDetails;


const Wrapper = styled.div`
    width:500px;
    display:flex;
    flex-direction: column;
    & > div:first-of-type{
        display: flex;
        padding:20px 30px;
        gap:30px;
        align-items:center;
        background-color: #E0FAEE;
    }
    & > div:first-of-type > img{
        width:80px;
    }
    & > div:first-of-type > div{
        display: flex;
        flex-direction: column;
        gap:10px;
    }
    & > div:first-of-type > div > span:nth-of-type(1){
        font-size:18px;
        font-weight:bold;
    }
    & > div:first-of-type > div > span:nth-of-type(2){
        font-weight:500;
    }
    & > div:nth-of-type(2){
        padding:30px;
        background-color:var(--white-color);
    }
`
 
const EachDetails = (props:any) =>{
    const label = props.label?props.label:'Label';
    const value = props.value?props.value:"Value";

    return (
        <StyledDetails>
            <span>{label}</span>
            <span>{value}</span>
        </StyledDetails>
    )
}

const StyledDetails = styled.div`
    display: flex;
    flex-direction:column;
    gap:10px;
    margin-top:10px;
    border-bottom: 1px solid #E2E4E8;
    padding:10px 0;
    & > span:first-of-type{
        font-weight:500;
    }
    & > span:nth-of-type(2){
        color:#666666;
    }
`

const CenterBtnDiv = styled.div`
    display:flex;
    align-items:center;
    justify-content: center;
    padding:10px 0;
    gap:20px;
    & > button{
        outline:none;
        cursor:pointer;
    }
    & > button.decline{
        padding: 12px 25px;
        background-color:var(--white-color);
        color:#EB5757;
        border:1px solid #EB5757;
        border-radius:5px;
    }
    & > button.approve{
        padding: 12px 25px;
        background-color:#5BC065;
        color:var(--white-color);
        border:1px solid #5BC065;
        border-radius:5px;
    }
`
